export default "__VITE_ASSET__CVaFQBJW__"